/*!
 * egis scripts
 */

// Global Pixel name space
const $_GP = window.$_GP || {};
$_GP.fn  = $_GP.fn || {};
$_GP._ = $_GP._ || {};

// iife`s
	(function() {
	
		let docElm = document.documentElement;
	
		docElm.className = docElm.className.replace('no-js','js');
	
		if (!window.console || typeof window.console === 'undefined') {
			window.console = {
				log: function() {},
				error: function() {}
			};
		}
	
		if (!('requestAnimationFrame' in window)) {
			docElm.className += ' no-raf';
		}
	
	}());
	
	
	(function() {
		var switchTo5x=true;
		var e=document.createElement("script");
		e.type="text/javascript";
		e.async=true;
		e.onload=function() {
			try {
				stLight.options({
					publisher: "6d5be87d-2b8f-4e73-a526-97ae308ea596",
					shorten:false,
					doNotHash: true,
					onhover: false
				});
			} catch(e) { throw e; }
		};
		e.src=('https:' == document.location.protocol ? 'https://ws' : 'http://w') + '.sharethis.com/button/buttons.js';
		// var s = document.getElementsByTagName('script')[0];
		// s.parentNode.insertBefore(e, s);
		document.body.appendChild(e);
	}());
	

// helpers without dependencies $_GP._
	/**
	 * This function will check up the inheritance chain, a better typeof
	 * @example
		$_GP._.is('number', 33) // true
		$_GP._.is('number', '33') // false
		$_GP._.is('number', NaN) // false
	 * @param {string} str - name to test
	 * @param {*} objType - any js object
	 * @returns {boolean}
	 */
	$_GP._.is = function(str, objType) {
		// TODO
		// is('nan', NaN)
		// is('nil', null) > null || undefined
	
		const types  = 'array object string date regexp function boolean number null undefined symbol'.split(' ')
		const validStr = types.some(t=> str === t)
	
		if (!validStr) {
			console.error('Error: first argument is not a valid data type.')
			return;
		}
	
		const type = Object.prototype.toString.call(objType).slice(8, -1).toLocaleLowerCase();
	
		if (str === 'number' && type === 'number') {
			return objType === objType
		}
	
		return str === type
	}
	
	
	$_GP._.throttle = function(fn, timeWindow, scope) {
		'use strict';
	
		timeWindow = timeWindow || (timeWindow = 200);
		var last, deferTimer;
	
		return function() {
			var context = scope || this;
			var now = new Date().getTime();
			var args = arguments;
	
			if (last && now < last + timeWindow) {
				clearTimeout(deferTimer);
				deferTimer = setTimeout(function() {
					last = now;
					fn.apply(context, args);
				}, timeWindow);
			}
			else {
				last = now;
				fn.apply(context, args);
			}
		};
	};
	
	
	$_GP._.debounce = function (fn, wait) {
	
		wait = wait || 250;
	
		var timeout;
		return function () {
			const context = this;
			const args = arguments;
	
			var later = function () {
				timeout = null;
				fn.apply(context, args);
			};
	
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
		};
	};
	

(function (window, document, $) {

	/**
	 * Create jQuery children of data-node
	 * @example
	
	 * @param {string|jQuery} elm - string id or jQuery id element
	 * @returns {object} jQuery datepicker object
	 */
	$_GP.fn.dataNode = function(elm) {
		elm = $(elm);
		if (!elm.length) return;
		elm = elm.eq(0);
		const nodeExt = elm.data('node')
	
		return {
			el(nodeName) {
				return elm.find(`[data-node-${nodeExt}="${nodeName}"]`)
			}
		}
	};
	
	
	$_GP.globalCall = (function() {
	
		// const $doc    = $(document)
		const $window = $(window)
		const body   = $('body')
	
		const twbsCalls = function() {
			const dropdownMenu = $('ul.dropdown-menu [data-toggle=dropdown]');
			dropdownMenu.on('click', function(ev) {
				ev.preventDefault();
				ev.stopPropagation();
				dropdownMenu.parent().removeClass('open');
				$(this).parent().addClass('open');
			});
		}
	
		const editorIframeYT = function() {
			const ytIframe16by9 = $('.content-editable iframe[src*="www.youtube.com"]:not(.content-editable .embed-responsive-16by9 iframe[src*="www.youtube.com"])');
	
			if (ytIframe16by9.length > 0) {
				ytIframe16by9.attr('allowfullscreen', '')
					.wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
			}
		}
	
		const headerFixed = function() {
	
			let FIXED = false;
	
			const fixed = function() {
				const distTop = $window.scrollTop();
	
				if (!FIXED && distTop > 50) {
					body.addClass('header-fixed');
					FIXED = true;
				}
	
				if (FIXED && distTop <= 50 ) {
					body.removeClass('header-fixed');
					FIXED = false;
				}
			};
	
			fixed();
	
			$window.scroll($_GP._.throttle(fixed));
		}
	
		const navbarToggle = function() {
			const header   = $('#header');
			const triggers = header.find('[data-ev="btnNavbarToggle"]');
			let isOpen = false;
	
			triggers.on('click', ()=> {
				isOpen = !isOpen
				body.toggleClass('header-navbar-is-open',isOpen)
				triggers.attr('aria-expanded', isOpen);
			})
		}
	
		const cookieWarning = function() {
			$(function() {
				const warning       = $('#browser-cookie-warning');
				const btn           = warning.find('button');
				const warningClosed = Cookies.get('gpb_cookieWarningClosed');
	
				if (!warningClosed) warning.addClass('show');
	
				btn.on('click', ()=> Cookies.set('gpb_cookieWarningClosed', 'true', { expires: 365 }));
			});
		}
	
		const clickScroll = function() {
			const btn = $('[data-node="scrollView"]');
			const scroll = function() {
				const headerHeight = $('.header-bottom').outerHeight()
				const barHeight = $(this).closest('.titles-bar-top').outerHeight()
				const dist = window.innerHeight - (barHeight + headerHeight)
				$('html,body').stop().animate({scrollTop: dist})
			}
			btn.on('click', scroll)
		}
	
		const countCharacters = function() {
			const trigger = $('[data-node-counter="trigger"]');
	
			trigger.on('keyup blur focus', function() {
				const _this = $(this)
				const len = _this.val().length
				_this.closest('[data-node="counter"]').find('[data-node-counter="target"]').text(len)
			});
		}
	
		cookieWarning()
		editorIframeYT()
		headerFixed()
		twbsCalls()
		navbarToggle()
		clickScroll()
		countCharacters()
	}());
	
	/**
	 * Control modal and ajax request page for the RGPD
	 * @module $_GP.privacyControl
	 * @returns {object}
	 */
	$_GP.privacyControl = (function() {
	
		let FORM_TO_SUBMIT = null;
		let PRIVACY_AGREE  = false;
		let PRIVACY_URL    = null;
	
		const setForm = (form)=> FORM_TO_SUBMIT = $(form)
		const getForm = ()=> FORM_TO_SUBMIT
		const setPrivacyAgree = (bool)=> PRIVACY_AGREE = bool
		const getPrivacyAgree = ()=> PRIVACY_AGREE
	
		const requestDataVault = function() {
			let DATA = null;
			return {
				getData : function() { return DATA; },
				setData: function(data) { DATA = data; },
				request: function(url) {
					return $_GP.ajax(url, null, 'json');
				}
			};
		}
	
		const requestPrivacyPolicy = requestDataVault();
	
		/**
		 * Control modal and ajax reques for the RGPD
		 * @example
			$_GP.privacyControl.run({ url: 'url/to/endpoint'});
		 * @param {object} opt - options, $_GP.ajax options
		 * @returns {undefined}
		 * @requires $_GP.ajax
		 */
		const run = function(opt) {
	
			const modal = $('#modal-privacy');
	
			if (!modal.length) {
				console.error('Bootstrap modal with id="modal-privacy" is required!!!')
				return false
			}
	
			if (!opt.url) {
				console.error('Option "url" is required')
				return false
			}
			PRIVACY_URL = opt.url
			let MODAL_HAS_RGPD_HTML = false
	
			modal.find('[data-toggle="modal-agree"]').on('change', function(ev) {
				const agree = $(this).prop('checked');
				if (agree) {
					PRIVACY_AGREE = true;
					modal.find('[data-action="ok"]').removeClass('btn-default')
						.addClass('btn-brand').prop('disabled', false);
					FORM_TO_SUBMIT.find('[data-privacy]').val('1');
				} else {
					PRIVACY_AGREE = false;
					modal.find('[data-action="ok"]').removeClass('btn-brand')
						.addClass('btn-default').prop('disabled', true);
					FORM_TO_SUBMIT.find('[data-privacy]').val('');
				}
			});
	
			modal.find('[data-action="ok"]').on('click', function name(ev) {
				if (!PRIVACY_AGREE) return;
				FORM_TO_SUBMIT.submit()
			});
	
			modal.on('show.bs.modal', function() {
				if (MODAL_HAS_RGPD_HTML) return
	
				const requestData = requestPrivacyPolicy.getData();
	
				if (!requestData) {
					const $ajax = requestPrivacyPolicy.request(opt.url).done(function(resp) {
						requestPrivacyPolicy.setData(resp);
						modal.find('.modal-body-scroll').html(resp.html);
						modal.find('.modal-title').html(resp.title);
						MODAL_HAS_RGPD_HTML = true
						if (opt.done) opt.done(resp);
					});
	
					if (opt.$ajax) opt.$ajax(modal,$ajax);
				} else {
					modal.find('.modal-body-scroll').html(requestData.html);
					modal.find('.modal-title').html(requestData.title);
					MODAL_HAS_RGPD_HTML = true
					if (opt.done) opt.done(requestData);
				}
			});
	
			modal.on('hide.bs.modal', function(ev) {
				FORM_TO_SUBMIT = null;
				PRIVACY_AGREE = false;
				modal.find('[data-toggle="modal-agree"]').prop('checked', false);
				modal.find('[data-action="ok"]').removeClass('btn-brand')
					.addClass('btn-default').prop('disabled', true);
			});
		}
	
		const steps = (function() {
			let s = 1
			return {
				get: ()=> s,
				inc: ()=> s += 1,
				reset: ()=> s = 1
			}
		}())
	
		/**
		 * Control ajax requet for the RGPD inside modal with form
		 * @example
			$_GP.privacyControl.insideModal(formBook, {
				url: 'url/to/endpoint',
				done: function(resp) {
					console.log(resp);
				}
			});
		 * @param {string|jQuery} elm - form elements
		 * @param {object} opt - options, $_GP.ajaxSubmitInner options
		 * @returns {undefined}
		 * @requires $_GP.ajax, $_GP.ajaxSubmitInner
		 */
		const insideModal = function(form, opt={}) {
			form = $(form)
			const modal = form.closest('.modal')
			if (!form.length || !modal.length) return
	
			if (!form.find('[data-privacy]').length) {
				console.error(`data-privacy in #${form.attr('id')} is required (<input type="hidden" name="txtPrivacy" data-privacy>)!!!`)
				return false
			}
	
			if (opt.fileinput === true && !opt.request) {
				console.error('Option request is required !!!')
				return false
			}
	
			opt.RGPD = opt.RGPD || {}
			let MODAL_HAS_RGPD_HTML = false
			const $_ = $_GP.fn.dataNode(form);
	
			const resetStep = function(ev) {
				$_.el('btnSubmit').addClass('btn-brand').prop('disabled', false)
				form.find('[data-privacy]').val('')
				form.find('[data-toggle="modal-agree"]').prop('checked', false);
				$_.el('step-1').slideDown()
				$_.el('step-2').slideUp()
				steps.reset()
			}
	
			form.find('[data-toggle="modal-agree"]').on('change', function(ev) {
				const agree = $(this).prop('checked')
				if (agree) {
					$_.el('btnSubmit').addClass('btn-brand').prop('disabled', false)
					form.find('[data-privacy]').val('1')
				} else {
					$_.el('btnSubmit').removeClass('btn-brand').prop('disabled', true)
					form.find('[data-privacy]').val('')
				}
			});
	
			modal.on('show.bs.modal', function() {
				if (MODAL_HAS_RGPD_HTML) return
	
				const requestData = requestPrivacyPolicy.getData();
	
				if (!requestData) {
					const $ajax = requestPrivacyPolicy.request(PRIVACY_URL).done(function(resp) {
						requestPrivacyPolicy.setData(resp);
						modal.find('.modal-body-scroll').html(resp.html);
						MODAL_HAS_RGPD_HTML = true
						if (opt.RGPD.done) opt.RGPD.done(resp);
					});
					if (opt.RGPD.$ajax) opt.RGPD.$ajax(modal, $ajax);
				} else {
					modal.find('.modal-body-scroll').html(requestData.html);
					MODAL_HAS_RGPD_HTML = true
					if (opt.RGPD.done) opt.RGPD.done(requestData);
				}
			});
	
			modal.on('hidden.bs.modal', resetStep);
	
			form.on('submit', function() {
				if (steps.get() === 1) {
					$_.el('step-1').slideUp()
					$_.el('step-2').slideDown()
					$_.el('btnSubmit').removeClass('btn-brand').prop('disabled', true)
					steps.inc()
					return false
				}
	
				if (steps.get() === 2) {
					if (opt.fileinput !== true) {
						$_GP.ajaxSubmitInner(form, opt).done(function(resp) {
							if (!resp.success) {
								resetStep()
								return false
							}
							modal.modal('hide')
						});
					} else {
						opt.request(form,opt)
					}
				}
	
				return false
			});
		};
	
		return { run, setForm, getForm, setPrivacyAgree, getPrivacyAgree, insideModal}
	}());
	
	/**
	 * For $.ajax requests
	 * csrfCookieGP is always send
	 * If cookie is expired show spop and throw error
	 * @example
		$('#select-element').on('change', function(ev) {
			var _this = $(this);
			if (!_this.val()) return;
	
			var data = '&val=' + _this.val();
	
			$_GP.ajax('url/to/endpoint', data, 'html').done(function(resp) {
				// request succeded
			}).fail(function() {
				// request fail
			}).always(function() {
				// request end
			});
		});
	 * @param {string} url - endpoint, $.ajax url
	 * @param {string|object|null} data - $.ajax data
	 * @param {string} [dataType='json'] - $.ajax dataType
	 * @param {string} [type='POST'] - $.ajax type
	 * @returns {object} $.ajax request
	 * @requires $_GP._.is
	 * @requires js.cookie-2.1.2-min.js
	 * @requires spop-0.1.2.min.js
	 */
	$_GP.ajax = function( url, data, dataType, type) {
		if (!url) throw new Error('"url" is required!');
	
		dataType = dataType || 'json';
		type = type || 'POST';
	
	
		const cookieValue = Cookies.get('csrfCookieGP');
	
		const ignoreCsrf = $_GP.CSRF_EXCLUDE.some((v)=> v === url)
	
		if (!ignoreCsrf && !cookieValue) {
			spop({ template: $_GP.msm.submitCookieExpired, style: 'error', group: 'submitCookieExpired'});
			throw new Error('Cookie Expired!');
		}
	
		$('input[name="csrfTokenGP"]').val(cookieValue);
	
		if ($_GP._.is('string', data)) {
			if (!ignoreCsrf) data = data + '&csrfTokenGP=' + cookieValue;
		} else if ($_GP._.is('object', data)) {
			if (!ignoreCsrf) data.csrfTokenGP = cookieValue;
		} else if ($_GP._.is('null', data)) {
			if (!ignoreCsrf) data = '&csrfTokenGP=' + cookieValue;
		} else {
			throw new Error('Invalid "data"!. String, object or null');
		}
	
		return $.ajax({
			url:      url,
			data:     data,
			dataType: dataType,
			type:     type
		});
	};
	
	/**
	 * $.ajax request width $.fn.serialize() for all, valid, inputs
	 * @example
		$('#form').on('submit', function(ev) {
			ev.preventDefault();
			var extraData = '&dataNotInSerialize=12345';
	
			$_GP.ajaxSubmitInner('#form', {
				url: 'url/to/endpoint',
				data: extraData,
				formReset: false,
				done: function(resp) {
					// request succeded and resp.success === true
				},
				$ajax: function($elm, request) {
					// $elm = $('#form')
					// request = $.ajax request
				}
			});
	
			return false;
		});
	 * @param {string|jQuery} elm - form element
	 * @param {object} opt - options
	 * @property {string} opt.url - endpoint, $.ajax url
	 * @property {string|object} [opt.data] - extradata to ben send in $.ajax data
	 * @property {string} [opt.dataType='json'] - $.ajax dataType
	 * @property {string} [opt.type='POST'] - $.ajax type
	 * @property {boolean} [opt.formReset=true] - reset form in done and !!resp.success
	 * @property {string} [opt.submitFailMsm=$_GP.msm.submitFail] - fail msm
	 * @property {function} [opt.done(resp)] - callback in request done and resp.success is truthy
	 *   @param {*} resp - depends in $.ajax response
	 * @property {function} [opt.$ajax($elm, request)] - callback
	 *   @param {jQuery} $elm - form element
	 *   @param {object} request - $.ajax request
	 * @returns {object} $.ajax request
	 * @requires $_GP.ajax,$_GP.msm.submitFail
	 */
	$_GP.ajaxSubmitInner = function(elm, opt) {
		const $elm = $(elm);
		const serializeWithoutToken = $elm.find('input[name!="csrfTokenGP"], textarea, select').serialize();
	
		let data;
		if ($_GP._.is('string', opt.data)) {
			data = serializeWithoutToken + opt.data;
		} else if ($_GP._.is('object', opt.data)) {
			data = serializeWithoutToken + '&' + $.param(opt.data);
		} else {
			data = serializeWithoutToken;
		}
	
		const request = $_GP.ajax( opt.url, data, opt.dataType, opt.type);
	
		const formReset = opt.formReset === false ? false : true;
	
		$elm.find('button[type="submit"]').prop('disabled', true)
			.find('.fa-sync').removeClass('hide');
	
		request.done(function(resp) {
			if (!resp.success) {
				spop({ template: resp.info, style: 'error', group: elm});
				return;
			}
	
			spop({ template: resp.info, style: 'success', group: elm, autoclose: 5000 });
	
			if (formReset) $elm[0].reset();
	
			if (opt.done) opt.done(resp);
	
		}).fail(function() {
			spop({template: (opt.submitFailMsm ? opt.submitFailMsm : $_GP.msm.submitFail), style: 'error', group: elm });
		}).always(function() {
			$elm.find('button[type="submit"]').prop('disabled', false)
				.find('.fa-sync').addClass('hide');
		});
	
		if (opt.$ajax) opt.$ajax($elm, request);
	
		return request;
	};
	
	/**
	 * Submit a form element
	 * @example
		$_GP.ajaxSubmit('#form', {
			url: 'url/to/endpoint',
			data: '&dataNotInSerialize=12345',
			formReset: false,
			done: function(resp) {
				// request succeded and resp.success === true
			},
			$ajax: function($elm, call) {
				// $elm = $('#form')
				// call = $.ajax request
			}
		});
	 * @param {string|jQuery} elm - form element
	 * @param {object} opt - options, $_GP.ajaxSubmitInner options
	 * @returns {undefined}
	 * @requires $_GP.ajaxSubmitInner
	 */
	$_GP.ajaxSubmit = function(elm, opt) {
		const submit = function(ev) {
			ev.preventDefault();
	
			$_GP.ajaxSubmitInner(elm, opt);
	
			return false;
		};
	
		$(elm).on('submit', submit);
	};
	
	/**
	 * Delegate form submition to a method
	 * @module $_GP.ajaxDelegate
	 */
	$_GP.ajaxDelegate = (function() {
	
		/**
		 * Form submition controled by $_GP.privacyControl
		 * @example
			$_GP.ajaxDelegate.privacyControl('#form', {
				url: 'url/to/endpoint'
			});
		 * @param {string|jQuery} form - form element
		 * @param {object} opt - options, $_GP.ajaxSubmitInner options
		 * @returns {undefined}
		 * @requires $_GP.privacyControl, $_GP.ajaxSubmitInner
		 */
		const privacyControl = function(form, opt) {
			form = $(form)
			if (!form.length) return
	
			if (!form.find('[data-privacy]').length) {
				console.error(`data-privacy in #${form.attr('id')} is required (<input type="hidden" name="txtPrivacy" data-privacy>)!!!`)
				return false
			}
	
			const modal = $('#modal-privacy');
			let SUBMITING = false;
	
			form.on('submit', function(ev) {
				ev.preventDefault()
				if (SUBMITING) return
	
				$_GP.privacyControl.setForm(form)
	
				if (!$_GP.privacyControl.getPrivacyAgree()) {
					modal.modal('show')
					return false
				}
	
				if ($_GP.privacyControl.getPrivacyAgree()) {
					SUBMITING = true
					modal.modal('hide');
	
					$_GP.ajaxSubmitInner(form, opt).always(function() {
						SUBMITING = false;
						form.find('[data-privacy]').val('');
					});
				}
	
				return false;
			});
		}
	
		return { privacyControl }
	}());
	
	
	$_GP.ajaxCaptchaRequest = function(elm,url,argOpt) {
		elm = $(elm);
		if (!elm.length) return
	
		argOpt = argOpt || {}
		const dataOpt = elm.data('opt') || {}
	
		const opt = $.extend({}, dataOpt, argOpt)
	
		const ajax = $_GP.ajax(url, opt.sendData, 'html', 'POST');
	
		ajax.done(function (resp) {
			if (resp) {
				elm.removeClass('d-n');
				elm.find('input').removeAttr('disabled');
				elm.find('img').attr('src', $(resp).attr('src'));
			} else {
				elm.addClass('d-n');
				elm.find('input').attr('disabled', 'disabled');
			}
		});
	
		return ajax
	}
	
	$_GP.ajaxCaptcha = function(url) {
		const container = $('[data-captcha="container"]')
		if (!container.length) return
	
		let captchas = {}
	
		container.find('[data-captcha="trigger"]').on('click', function(ev) {
			$_GP.ajaxCaptchaRequest($(this).closest('[data-captcha="container"]'),url)
		});
	
		container.each((i,elm)=> {
			elm = $(elm)
			captchas[elm.data('opt').name] = {}
			const ajax = $_GP.ajaxCaptchaRequest(elm,url)
			captchas[elm.data('opt').name].elm = elm
			captchas[elm.data('opt').name].ajax = ajax
		})
	
		return captchas
	};
	
	
	$_GP.fileInput = function(elm) {
		elm = $(elm)
		if (!elm.length) return
	
		let $_ = $_GP.fn.dataNode(elm);
	
		const inputClone = $_.el('input').clone();
	
		const addInfo = function(str) {
			$_.el('name').text(str? str : '')
		};
	
		const addState = function() {
			$_.el('text-pick').removeClass('d-n');
			$_.el('text-change').addClass('d-n');
			$_.el('delete').addClass('d-n');
		};
	
		const removeState = function() {
			$_.el('text-pick').addClass('d-n');
			$_.el('text-change').removeClass('d-n');
			$_.el('delete').removeClass('d-n');
		};
	
		const reset = function() {
			// ie fix reset fileinput
			$_.el('input').remove();
			elm.prepend(inputClone);
			$_ = $_GP.fn.dataNode(elm);
	
			addInfo();
			addState();
		};
	
		const events = function() {
	
			elm.on('change', '[data-node-fileinput="input"]', function(ev) {
				if (this.files.length) {
					removeState();
					addInfo(this.files[0].name);
				} else {
					addState();
					addInfo();
				}
			});
	
			elm.on('click', '[data-node-fileinput="delete"]', function(ev) {
				ev.preventDefault();
				reset();
			});
	
			elm.on('focus', '[data-node-fileinput="input"]', function(ev) {
				elm.addClass('form-fileinput-focus');
			});
	
			elm.on('blur', '[data-node-fileinput="input"]', function(ev) {
				elm.removeClass('form-fileinput-focus');
			});
		};
	
		events();
	
		return {
			reset
		}
	};
	
	
	
	
	$_GP.grid = {}
	
	const _chunk = (size, arr)=> {
		var results = [];
	
		while (arr.length) {
			results.push(arr.splice(0, size));
		}
	
		return results;
	}
	
	const _rand = (min,max)=> {
		return Math.floor(Math.random()*(max-min+1)+min);
	}
	
	const _randDifPrevious = (min,max)=> {
		let prev = max
		return function randFn() {
			const r = _rand(min,max);
			if ( r === prev) {
				return randFn()
			} else {
				prev = r
				return r
			}
		}
	}
	
	// const _randDif3 = _randDifPrevious(0,3)
	// Array.from(Array(40)).forEach(()=> {
	// 	console.log(_randDif3())
	// })
	
	const loopRebbot = (max)=> {
		const start = 0
		let count = 0
		return {
			inc() {
				if (count > max) count = 0
				return count++
			}
		}
	}
	
	const onScroll = (elm, fn )=> {
		return (ev)=> {
			const distTop      = $(window).scrollTop()
	
			const windowHeight = window.innerHeight;
			const elmHeight    = elm.height()
			const elmDistTop   = elm.offset().top
			const trigger = (elmDistTop + elmHeight) - (windowHeight + 200)
			if (distTop > trigger) {
				fn()
			}
		}
	}
	
	$_GP.grid.parseData = function(data, opt={}) {
		data = data.concat([])
		opt.firstChunck = opt.firstChunck || 3
		opt.chunks = opt.chunks || 2
	
		let NEW_DATA = []
	
		if (data.length <= opt.firstChunck) {
			NEW_DATA = _chunk(opt.firstChunck, data)
		} else {
			let top = data.splice(0, opt.firstChunck)
			let bottom = _chunk(opt.chunks, data)
			NEW_DATA.push(top)
			NEW_DATA = NEW_DATA.concat(bottom)
		}
	
		return NEW_DATA
	}
	
	$_GP.grid.run = function(elm, options={}) {
		elm = $(elm);
		if (!elm.length) return;
	
		const defaults = {
			postIncrementName: 'counter',
			postExtraData: {}
		}
		const opt = $.extend({}, defaults, options)
	
		if (!opt.url) {
			console.error('url/to/endpoint is requrired!')
			return;
		}
	
		const postData = opt.postExtraData
		postData[opt.postIncrementName] = -1
	
		let HAS_TEMPLATES = true
		const templates = $_GP.grid.templates(opt)
	
		const addTemplates = function(allTemplates) {
			if (!HAS_TEMPLATES) return
			postData[opt.postIncrementName] +=1
	
			const $ajax = $_GP.ajax(opt.url, postData).done(function(resp) {
				if (!resp) {
					HAS_TEMPLATES = false
					if (allTemplates) allTemplates()
					return
				}
	
				const data = $_GP.grid.parseData(resp.data)
				const _randDif3 = _randDifPrevious(0,3)
	
				const html = data.reduce((acc, arr)=> {
					const len = arr.length
					if (len === 3) {
						acc.push(templates.grid_3[_rand(0,1)](arr))
					} else if (len == 1) {
						acc.push(templates.grid_1[0](arr))
					} else {
						acc.push(templates.grid_2[_randDif3()](arr))
					}
	
					return acc
				}, []).join('')
	
				elm.append(html)
	
				if (!resp.hasMore) {
					HAS_TEMPLATES = false
					if (allTemplates) allTemplates()
				}
			});
	
			if (opt.$ajax) opt.$ajax(elm, $ajax)
		}
	
	
		if (HAS_TEMPLATES && opt.loadOn === 'scroll load') {
			addTemplates()
			$(window).on('scroll', $_GP._.throttle(onScroll(elm, addTemplates)))
		}
	
		if (HAS_TEMPLATES && opt.loadOn === 'scroll') {
			$(window).on('scroll', $_GP._.throttle(onScroll(elm, addTemplates)))
		}
	
		if (HAS_TEMPLATES && opt.loadOn === 'click load') {
			addTemplates()
			$('#'+ elm.attr('id') +'-btn-load').on('click', function(ev) {
				addTemplates(()=> $(this).addClass('d-n'))
			})
		}
	};
	
	$_GP.grid.templates = function(opt) {
		const imgBlock = opt.imageTpl || function(data) {
			let cats = ''
	
			if (data.categories && data.categories.length) {
				cats = `
					<div class="grid-link-cats m-b-0 tt-u">
						${data.categories.map((cat)=> `<a href="${cat.url}">${cat.label}</a>` ).join(', ')}
					</div>
				`
			}
	
			return `
				<div class="grid-links" tabindex="0">
					<a class="grid-link" href="${data.url}">
						<div class="grid-link-img">
							<img class="img-responsive" src="${data.imgUrl}" alt="">
						</div>
					</a>
					<div class="grid-link-caption">
						<h3 class="grid-link-title h2 m-b-0">${data.title}</h3>
						${cats}
					</div>
				</div>
			`;
		}
	
		const grid_1_1 = function(data) {
			return `
				<div class="row grid-1-1">
					<div class="col-md-6">
						<div class="grid-item grid-item-3x2">
							${imgBlock(data[0])}
						</div>
					</div>
	
					<div class="col-md-6 hidden-sm">
						<div class="row">
							<div class="col-md-4">
								<div class="grid-item grid-item-1x1 bg-violet"></div>
							</div>
							<div class="col-md-4">
								<div class="grid-item grid-item-1x1 bg-brand"></div>
							</div>
							<div class="col-md-4">
								<div class="grid-item grid-item-1x1 bg-orange"></div>
							</div>
							<div class="col-md-4">
								<div class="grid-item grid-item-1x1 bg-blue"></div>
							</div>
							<div class="col-md-4">
								<div class="grid-item grid-item-1x1 bg-orange"></div>
							</div>
							<div class="col-md-4">
								<div class="grid-item grid-item-1x1 bg-violet"></div>
							</div>
						</div>
					</div>
				</div>
			`;
		}
	
		const grid_2_1 = function(data) {
			return `
				<div class="row grid-2-1">
					<div class="col-md-6">
						<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-orange"></div></div>
						<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-violet"></div></div>
						<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-brand"></div></div>
						<div class="col-sm-8">
							<div class="grid-item grid-item-2x1">
								${imgBlock(data[0])}
							</div>
						</div>
						<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-blue"></div></div>
					</div>
	
					<div class="col-md-6">
						<div class="grid-item grid-item-3x2">
							${imgBlock(data[1])}
						</div>
					</div>
				</div>
			`;
		}
	
		const grid_2_2 = function(data) {
			return `
				<div class="row grid-2-2">
					<div class="col-md-6">
						<div class="grid-item grid-item-3x2">
							${imgBlock(data[1])}
						</div>
					</div>
	
					<div class="col-md-6">
						<div class="row">
							<div class="col-md-8">
								<div class="grid-item grid-item-2x2">
									${imgBlock(data[0])}
								</div>
							</div>
	
							<div class="col-md-4 hidden-sm">
								<div class="grid-item grid-item-1x1 bg-violet"></div>
								<div class="grid-item grid-item-1x1 bg-orange"></div>
							</div>
						</div>
					</div>
				</div>
			`;
		}
	
		const grid_2_3 = function(data) {
			return `
				<div class="row grid-2-3">
					<div class="col-md-6">
						<div class="row">
							<div class="col-md-4 hidden-sm">
								<div class="grid-item grid-item-1x1 bg-blue"></div>
								<div class="grid-item grid-item-1x1 bg-orange"></div>
							</div>
	
							<div class="col-md-8">
								<div class="grid-item grid-item-2x2">
									${imgBlock(data[0])}
								</div>
							</div>
						</div>
					</div>
	
					<div class="col-md-6">
						<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-violet"></div></div>
						<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-blue"></div></div>
						<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-brand"></div></div>
						<div class="col-sm-12">
							<div class="grid-item grid-item-3x1">
								${imgBlock(data[1])}
							</div>
						</div>
					</div>
				</div>
			`;
		}
	
		const grid_2_4 = function(data) {
			return `
				<div class="row grid-2-4">
					<div class="col-md-6">
						<div class="grid-item grid-item-3x2">
							${imgBlock(data[0])}
						</div>
					</div>
	
					<div class="col-md-6">
						<div class="row">
							<div class="col-md-4 hidden-sm">
								<div class="grid-item grid-item-1x1 bg-brand"></div>
								<div class="grid-item grid-item-1x1 bg-orange"></div>
							</div>
	
							<div class="col-md-8">
								<div class="grid-item grid-item-2x2">
									${imgBlock(data[1])}
								</div>
							</div>
						</div>
					</div>
				</div>
			`;
		}
	
		const grid_3_1 = function(data) {
			return `
				<div class="row grid-3-1">
					<div class="col-md-6">
						<div class="row">
							<div class="col-sm-8">
								<div class="grid-item grid-item-2x1">
									${imgBlock(data[0])}
								</div>
							</div>
	
							<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-orange"></div></div>
							<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-blue"></div></div>
	
							<div class="col-sm-8">
								<div class="grid-item grid-item-2x1">
									${imgBlock(data[1])}
								</div>
							</div>
						</div>
					</div>
	
					<div class="col-md-6">
						<div class="grid-item grid-item-3x2">
							${imgBlock(data[2])}
						</div>
					</div>
				</div>
			`;
		}
	
		const grid_3_2 = function(data) {
			return `
				<div class="row grid-3-2">
					<div class="col-md-6">
						<div class="grid-item grid-item-3x2">
							${imgBlock(data[0])}
						</div>
					</div>
	
					<div class="col-md-6">
						<div class="row">
							<div class="col-sm-12">
								<div class="grid-item grid-item-3x1">
									${imgBlock(data[1])}
								</div>
							</div>
	
							<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-orange"></div></div>
	
							<div class="col-sm-8">
								<div class="grid-item grid-item-2x1">
									${imgBlock(data[2])}
								</div>
							</div>
						</div>
					</div>
				</div>
			`;
		}
	
		return {
			grid_1: [grid_1_1],
			grid_2: [grid_2_1, grid_2_2, grid_2_3, grid_2_4,],
			grid_3: [grid_3_1, grid_3_2],
		}
	}
	
	
	$_GP.formSearchFilter = function(elm, opt) {
	
		elm = $(elm);
		if (!elm.length) return;
	
		toggler  = elm.find(opt.toggler);
		dpStart  =  elm.find(opt.dpStart);
		dpEnd    =  elm.find(opt.dpEnd);
	
		var changeDatepiker = function () {
			var data = toggler.find('option:selected').data('datepicker');
			dpStart.add(dpEnd).prop('disabled', true).val('');
	
			if (!data) return;
	
			dpStart.prop('disabled', false);
	
			data.forEach(function(e) {
				elm.find('[name="'+ e.elm +'"]')
					.datepicker('option', 'maxDate', (e.opt.maxDate || null) )
					.datepicker('option', 'minDate', (e.opt.minDate || null) );
			});
		};
	
		$(window).on('load', changeDatepiker);
	
		toggler.change(changeDatepiker);
	};
	
	// https://stackoverflow.com/questions/14432571/control-html5-validation-balloon-scroll
	$_GP.formInvalidScroll = function (form) {
		form = form instanceof jQuery ? form : $(form);
		if (!form.length) return;
		const container = $('html, body');
	
		form.find('[required]').on('invalid', function () {
			var windowHeight = $(window).height();
			var windowQuarter = windowHeight / 5;
			var invalidDistTop = form.find('input:invalid, textarea:invalid, select:invalid').first().offset().top - windowQuarter;
	
			if (invalidDistTop > window.pageYOffset && invalidDistTop < (window.pageYOffset + windowHeight - windowQuarter)) {
				return true;
			} else {
				container.scrollTop(invalidDistTop);
			}
		});
	};
	
	/**
	 * Create jQuery UI datepickers with some defaults
	 * @example
		$_GP.fn.datepicker('#form input', {
			minDate: "0D",
			changeMonth: true,
			changeYear: true,
		});
	 * @param {string|jQuery} elm - base element
	 * @param {object} opt - jQuery UI datepicker options
	 * @returns {object} jQuery datepicker object
	 */
	$_GP.fn.datepicker = function(elm, opt) {
	
		elm = elm instanceof jQuery ? elm : $(elm);
		if (!elm.length) return;
	
		var defaults = {
			prevText: "&#xf104;",
			nextText: "&#xf105;",
			dateFormat: 'dd-mm-yy',
			duration: 'fast'
		};
	
		var options = $.extend({}, defaults, opt);
	
		return elm.datepicker(options).on('focus', function(){
			$(this).trigger('blur');
		});
	};
	
	/**
	 * @module $_GP.fn.slick
	 * @example
		$_GP.fn.slick.slickSimple('#slick-element', {
			arrows: true,
			cssEase: 'ease',
			centerMode: false,
			dots: false,
			draggable: true,
		});
	 * @returns {object} slicks objects
	 * @property {object} slick.slickSimple
	 * @property {object} slick.slickFull
	 */
	$_GP.fn.slick = (function() {
		/**
		 * Base slick with few defaults set
		 * @param {string} elm - base element
		 * @param {object} opt - slick options
		 * @returns {object} slick object
		 */
		const slickSimple = function(elm, opt) {
			elm = $(elm);
			opt = opt || {};
			if (!elm.length) return;
	
			const dataOpt = elm.data('slick') || {};
	
			const defaults = {
				infinite: true,
				speed: 300,
				slidesToShow: 1,
				slidesToScroll: 1
			};
	
			const options = $.extend({}, defaults, dataOpt, opt);
	
			return elm.slick(options);
		};
	
		/**
		 * Slick with a lot of defaults set
		 * @param {string} elm - base element
		 * @param {object} opt - slick options
		 * @returns {object} slick object
		 */
		const slickFull = function(elm, opt) {
			elm = $(elm);
			opt = opt || {};
			if (!elm.length) return;
	
			const dataOpt = elm.data('slick') || {};
	
			const defaults = {
				infinite: true,
				lazyLoad: 'ondemand',
				speed: 300,
				slidesToShow: 6,
				slidesToScroll: 1,
				autoplay: false,
				autoplaySpeed: 5000,
				responsive: [
					{
						breakpoint: 1200,
						settings: { slidesToShow: 5}
					},
					{
						breakpoint: 992,
						settings: { slidesToShow: 4}
					},
					{
						breakpoint: 768,
						settings: { slidesToShow: 3}
					},
					{
						breakpoint: 480,
						settings: { slidesToShow: 2}
					}
				]
			};
	
			const options = $.extend({}, defaults, dataOpt, opt);
	
			return elm.slick(options);
		};
	
		return {
			slickSimple: slickSimple,
			slickFull: slickFull
		};
	}());
	

}(window, document, window.jQuery));
